export default __webpack_public_path__ + "static/media/MM-Img2.22b1dea5.png";